"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountPageReadyEvent = void 0;
const event_type_1 = require("../enums/event-type");
class AccountPageReadyEvent {
    constructor(_accountPageApplication) {
        this._accountPageApplication = _accountPageApplication;
        this.eventType = AccountPageReadyEvent.EventType;
        this.timestamp = new Date();
        this.accountPageApplication = _accountPageApplication;
    }
}
exports.AccountPageReadyEvent = AccountPageReadyEvent;
AccountPageReadyEvent.EventType = event_type_1.EventType.ACCOUNT_PAGE_READY;
